import styled from 'styled-components';

export const PeopleDrawerContactIconWrapper = styled.div<{ disabled?: boolean }>`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
